import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=21138f3e&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
import style0 from "./Label.vue?vue&type=style&index=0&id=21138f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21138f3e",
  null
  
)

export default component.exports